/* AURA License Guard */
(function(){try{var _k='aura_lic_'+(window.Shopify&&Shopify.shop||location.hostname);var _c=JSON.parse(localStorage.getItem(_k)||'null');if(_c&&_c.exp>Date.now()&&!_c.valid){document.querySelectorAll('body *').forEach(function(e){e.style.cssText='display:none!important';});}}catch(e){}})();
/* ============================================================
   STRK.js - Main theme JavaScript
   ============================================================ */

window.STRK = window.STRK || {};

(function() {
  'use strict';

  const ease = 'cubic-bezier(0.16,1,0.3,1)';

  /* -- PAGE LOADER -- */
  window.addEventListener('load', function() {
    var loader = document.getElementById('aura-loader');
    if (!loader) return;

    /* Build blocks grid if needed */
    var blocksGrid = document.getElementById('ldr-blocks-grid');
    if (blocksGrid) {
      var cols = Math.ceil(window.innerWidth / 120);
      var rows = Math.ceil(window.innerHeight / 120);
      blocksGrid.style.setProperty('--cols', cols);
      blocksGrid.style.setProperty('--rows', rows);
      var total = cols * rows;
      for (var i = 0; i < total; i++) {
        var b = document.createElement('div');
        b.className = 'ldr-block';
        blocksGrid.appendChild(b);
      }
    }

    /* Dismiss after configured duration */
    var dur = parseInt(getComputedStyle(loader).getPropertyValue('--ldr-dur')) || 1600;
    var showTime = Math.max(400, dur * 0.6);
    setTimeout(function() {
      /* Stagger block removal for blocks style */
      if (blocksGrid) {
        var blocks = blocksGrid.querySelectorAll('.ldr-block');
        blocks.forEach(function(bl, idx) {
          bl.style.transitionDelay = (Math.random() * 0.4).toFixed(2) + 's';
        });
      }
      loader.classList.add('done');
      /* Full cleanup after animations finish */
      setTimeout(function() {
        loader.style.display = 'none';
      }, dur);
    }, showTime);
  });

  /* -- CURSOR -- */
  var cur = document.getElementById('cur');
  if (cur && matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mousemove', function(e) {
      cur.style.left = e.clientX + 'px';
      cur.style.top  = e.clientY + 'px';
      var el = e.target;
      if (el.tagName === 'IMG' || el.closest('.cmedia, .product-gallery, .film-item')) {
        cur.className = 'cur-dot on-img';
      } else if (el.closest('button, a, .mag-btn, .cart-trigger')) {
        cur.className = 'cur-dot on-btn';
      } else {
        cur.className = 'cur-dot';
      }
    });
  }

  /* -- HEADER SCROLL -- */
  var hdr = document.getElementById('strk-hdr');
  if (hdr) {
    window.addEventListener('scroll', function() {
      hdr.classList.toggle('scrolled', window.scrollY > 4);
    }, { passive: true });
  }

  /* -- MOBILE NAV -- */
  var mnav   = document.getElementById('mnav');
  var mbtn   = document.getElementById('hdr-mbtn');
  var mnavX  = document.getElementById('mnav-x');
  if (mnav && mbtn) {
    mbtn.addEventListener('click',  function() { mnav.classList.add('open'); });
    mnavX.addEventListener('click', function() { mnav.classList.remove('open'); });
    document.querySelectorAll('.mlink').forEach(function(l) {
      l.addEventListener('click', function() { mnav.classList.remove('open'); });
    });
  }

  /* -- SCROLL REVEAL -- */
  var ro = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -12px 0px' });
  document.querySelectorAll('.rv').forEach(function(el) { ro.observe(el); });

  /* -- TEXT SCRAMBLE -- */
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#@!';
  STRK.scramble = function(el, finalText, duration) {
    duration = duration || 900;
    var iter = 0;
    var iv = setInterval(function() {
      el.textContent = finalText.split('').map(function(c, i) {
        return i < iter ? finalText[i] : CHARS[Math.floor(Math.random() * CHARS.length)];
      }).join('');
      iter += finalText.length / (duration / 30);
      if (iter >= finalText.length) { el.textContent = finalText; clearInterval(iv); }
    }, 30);
  };

  /* Scramble hero name on load */
  var heroName = document.getElementById('hero-name');
  if (heroName) {
    var originalText = heroName.textContent.trim();
    heroName.textContent = originalText;
    window.addEventListener('load', function() {
      setTimeout(function() { STRK.scramble(heroName, originalText, 1000); }, 400);
    });
  }

  /* -- HERO SLIDER -- */
  var heroSlides   = document.getElementById('hero-slides');
  var heroDots     = document.querySelectorAll('.hero-dot');
  var heroPrev     = document.getElementById('hero-prev');
  var heroNext     = document.getElementById('hero-next');
  var slideCount   = document.querySelectorAll('.hero-slide').length;
  var currentSlide = 0;
  var autoTimer;

  function goToSlide(idx) {
    currentSlide = ((idx % slideCount) + slideCount) % slideCount;
    if (heroSlides) heroSlides.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    heroDots.forEach(function(d, i) { d.classList.toggle('active', i === currentSlide); });
  }

  function startAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(function() { goToSlide(currentSlide + 1); }, 5000);
  }

  if (heroSlides && slideCount > 1) {
    if (heroPrev) heroPrev.addEventListener('click', function() { goToSlide(currentSlide - 1); startAuto(); });
    if (heroNext) heroNext.addEventListener('click', function() { goToSlide(currentSlide + 1); startAuto(); });
    heroDots.forEach(function(d) {
      d.addEventListener('click', function() { goToSlide(parseInt(d.dataset.i)); startAuto(); });
    });
    // Touch swipe
    var tsx = 0;
    heroSlides.addEventListener('touchstart', function(e) { tsx = e.touches[0].clientX; }, { passive: true });
    heroSlides.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - tsx;
      if (Math.abs(dx) > 40) { goToSlide(dx < 0 ? currentSlide + 1 : currentSlide - 1); startAuto(); }
    });
    startAuto();
  }

  /* -- TICKER SPEED -- */
  var ticker = document.querySelector('.strk-ticker');
  if (ticker) {
    var tickRow = ticker.querySelector('.tick-row');
    if (tickRow) {
      ticker.addEventListener('mouseenter', function() { tickRow.style.animationDuration = '10s'; });
      ticker.addEventListener('mouseleave', function() { tickRow.style.animationDuration = '28s'; });
    }
  }

  /* -- 3D CARD TILT -- */
  document.querySelectorAll('[data-tilt]').forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      var r  = card.getBoundingClientRect();
      var cx = r.width / 2, cy = r.height / 2;
      var rotX = ((e.clientY - r.top  - cy) / cy) *  4;
      var rotY = ((e.clientX - r.left - cx) / cx) * -4;
      card.style.transform = 'perspective(800px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(1.01,1.01,1.01)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(800px) rotateX(0) rotateY(0) scale3d(1,1,1)';
    });
  });

  /* -- MAGNETIC BUTTON -- */
  var magBtn = document.getElementById('mag-btn');
  if (magBtn && matchMedia('(pointer:fine)').matches) {
    magBtn.addEventListener('mouseenter', function() { magBtn.style.transition = 'none'; });
    magBtn.addEventListener('mousemove', function(e) {
      var r = magBtn.getBoundingClientRect();
      magBtn.style.transform = 'translate(' + ((e.clientX - r.left - r.width/2) * 0.35) + 'px,' + ((e.clientY - r.top - r.height/2) * 0.35) + 'px)';
    });
    magBtn.addEventListener('mouseleave', function() {
      magBtn.style.transition = 'transform .5s ' + ease;
      magBtn.style.transform  = 'translate(0,0)';
      setTimeout(function() { magBtn.style.transition = ''; }, 500);
    });
  }

  /* -- FILM ROLL DRAG -- */
  var film = document.getElementById('film-scroll');
  if (film) {
    var fd = false, fsx = 0, fsl = 0;
    film.addEventListener('mousedown',  function(e) { fd = true; fsx = e.pageX - film.offsetLeft; fsl = film.scrollLeft; film.style.userSelect = 'none'; });
    film.addEventListener('mouseleave', function()  { fd = false; film.style.userSelect = ''; });
    film.addEventListener('mouseup',    function()  { fd = false; film.style.userSelect = ''; });
    film.addEventListener('mousemove',  function(e) { if (!fd) return; e.preventDefault(); film.scrollLeft = fsl - (e.pageX - film.offsetLeft - fsx) * 1.2; });
  }

  /* -- SPROCKET HOLES -- */
  function buildSprockets(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var count = Math.ceil(window.innerWidth / 32) + 4;
    el.innerHTML = Array(count).fill('<div class="sprocket"></div>').join('');
  }
  buildSprockets('sprockets-top');
  buildSprockets('sprockets-bot');

  /* -- PRODUCT PAGE: GALLERY -- */
  STRK.initProductGallery = function() {
    var track = document.getElementById('gallery-track');
    var dots  = document.querySelectorAll('.g-dot');
    if (!track) return;
    var cur = 0;
    var total = document.querySelectorAll('.gallery-slide').length;

    function gGoTo(idx) {
      cur = Math.max(0, Math.min(idx, total - 1));
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      dots.forEach(function(d, i) { d.classList.toggle('active', i === cur); });
    }

    var tsx = 0;
    track.addEventListener('touchstart', function(e) { tsx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   function(e) {
      var dx = e.changedTouches[0].clientX - tsx;
      if (Math.abs(dx) > 40) gGoTo(dx < 0 ? cur + 1 : cur - 1);
    });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { gGoTo(i); }); });
  };

  /* -- PRODUCT PAGE: VARIANT SELECT -- */
  STRK.selectVariant = function(btn, variantId, price) {
    document.querySelectorAll('.sz-btn').forEach(function(b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    var hiddenId = document.getElementById('variant-id');
    if (hiddenId) hiddenId.value = variantId;
    var atcBtn = document.getElementById('atc-btn');
    if (atcBtn) {
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add to Cart - ' + price;
    }
    var stickyPrice = document.getElementById('sticky-price');
    if (stickyPrice) stickyPrice.textContent = price;
    // Update URL without reload
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState(null, '', url.toString());
    }
  };

  /* -- PRODUCT PAGE: DESCRIPTION EXPAND -- */
  STRK.toggleDesc = function(btn) {
    var txt = document.getElementById('pdesc');
    if (!txt) return;
    txt.classList.toggle('expanded');
    btn.textContent = txt.classList.contains('expanded') ? 'Read less' : 'Read more';
  };

  /* -- PRODUCT PAGE: ACCORDION -- */
  STRK.toggleAccordion = function(item) {
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion-item').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  /* -- CART SYSTEM -- */
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer  = document.getElementById('cart-drawer');
  var drawerX     = document.getElementById('drawer-x');
  var btnContinue = document.getElementById('btn-continue');
  var cartTrigger = document.getElementById('cart-trigger');



  if (drawerX)    drawerX.addEventListener('click', function(){ if(window.CART) CART.close(); });
  if (btnContinue) btnContinue.addEventListener('click', function(){ if(window.CART) CART.close(); });
  if (cartOverlay) cartOverlay.addEventListener('click', function(e){ if (e.target === cartOverlay && window.CART) CART.close(); });
  if (cartTrigger) cartTrigger.addEventListener('click', function(e) { e.preventDefault(); window.location.href = '/cart'; });

  /* Add to cart via AJAX */
  STRK.addToCart = function(btn) {
    if (btn.classList.contains('so') || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var tray = btn.closest('.stray');
    var orig = tray ? tray.innerHTML : '';
    if (tray) tray.innerHTML = '<div style="padding:10px 0;text-align:center;font-family:var(--body);font-size:12px;font-weight:500;letter-spacing:.04em;">Adding...</div>';

    var restoreTray = function() {
      if (tray) setTimeout(function() { tray.innerHTML = orig; rebindSizes(); }, 1600);
    };

    if (window.CART && typeof CART.add === 'function') {
      CART.add(variantId, 1)
      .then(restoreTray)
      .catch(function(err) {
        console.error('Cart error:', err);
        if (tray) { tray.innerHTML = orig; rebindSizes(); }
      });
    } else {
      /* Fallback: direct fetch if CART object not ready */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function() {
        /* Update badge */
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
          var badge = document.getElementById('cart-count');
          if (badge) { badge.textContent = cart.item_count; }
        });
        restoreTray();
      })
      .catch(function(err) {
        console.error('Cart fallback error:', err);
        if (tray) { tray.innerHTML = orig; rebindSizes(); }
      });
    }
  };




  function rebindSizes() {
    document.querySelectorAll('.sp:not(.so)').forEach(function(b) {
      b.setAttribute('onclick', 'STRK.addToCart(this)');
    });
  }

  /* -- PRODUCT CARD: DUAL OPTION DROPDOWN MATCHING -- */
  window.strkCardDual = function(select) {
    var handle = select.dataset.handle;
    var card = select.closest('.stray');
    if (!card) return;

    var sel1 = card.querySelector('[data-card-opt="1"]');
    var sel2 = card.querySelector('[data-card-opt="2"]');
    var atcBtn = card.querySelector('.sp-dual-atc');
    if (!sel1 || !sel2 || !atcBtn) return;

    var o1 = sel1.value;
    var o2 = sel2.value;

    if (!o1 || !o2) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Add';
      return;
    }

    /* Get variant data from the JSON script tag */
    var jsonEl = document.getElementById('variants-' + handle);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch(e) { return; }

    var match = variants.find(function(v) {
      return v.option1 === o1 && v.option2 === o2;
    });

    if (match && match.available) {
      atcBtn.disabled = false;
      atcBtn.dataset.variantId = match.id;
      atcBtn.dataset.productPrice = '$' + (match.price / 100).toFixed(2);
      atcBtn.textContent = 'Add - $' + (match.price / 100).toFixed(2);
    } else if (match) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold Out';
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Unavailable';
    }
  };

  /* ATC form handled in main-product.liquid via CART.add() */

  /* -- NEWSLETTER INLINE OK -- */
  var nlForm = document.querySelector('.nlform');
  if (nlForm) {
    nlForm.addEventListener('submit', function(e) {
      var input = nlForm.querySelector('.nlinp');
      if (!input || !input.value) return;
      // Let Shopify handle the actual submission - just add visual feedback
      setTimeout(function() {
        var ok = document.querySelector('.nlok');
        if (ok) { nlForm.style.display = 'none'; ok.style.display = 'block'; }
      }, 300);
    });
  }

})();
